import { Injectable, SecurityContext } from '@angular/core';
import { ParamContext } from '../../service/param.context';
import { GERMPLASM_DETAILS_URL } from '../../../app.constants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable()
export class GermplasmDetailsUrlService {

    queryParams: string;

    constructor(
        private paramContext: ParamContext,
        private sanitizer: DomSanitizer
    ) {
        this.queryParams = '?cropName=' + this.paramContext.cropName
            + '&programUUID=' + this.paramContext.programUUID
            + '&loggedInUserId=' + this.paramContext.loggedInUserId
            + '&selectedProjectId=' + this.paramContext.selectedProjectId;
    }

    getUrl(gid: any): SafeResourceUrl {
        // Link to open Germplasm Details page to a new tab.
        return this.sanitizer.sanitize(SecurityContext.URL, this.getUrlAsString(gid));
    }

    getUrlAsString(gid: any): string {
        // Link to open Germplasm Details page to a new tab.
        return GERMPLASM_DETAILS_URL + gid + this.queryParams;
    }
}
